import { Inject, Injectable } from '@angular/core';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { activate, fetchAndActivate, getAll, getRemoteConfig, onConfigUpdate, RemoteConfig } from 'firebase/remote-config';
import { IXMOptions } from 'core/interfaces';
import { CONFIG_TOKEN } from 'core/constants';
import { Util } from 'core/services';

@Injectable({
    providedIn: 'root'
})
export class RemoteConfigService {
    public remoteConfig: RemoteConfig;
    private config: IXMOptions;

    constructor(@Inject(CONFIG_TOKEN) config: IXMOptions) {
        Object.assign(this, { config });
    }

    public async init(): Promise<RemoteConfigType> {
        const app: FirebaseApp = initializeApp(this.config.FIREBASE_CONFIG);
        this.remoteConfig = getRemoteConfig(app);
        this.remoteConfig.settings = this.config.FIREBASE_SETTINGS;
        
        await fetchAndActivate(this.remoteConfig);
        const fireConfig: object = getAll(this.remoteConfig);
        
        return Util.generateRemoteConfig(fireConfig, this.remoteConfig);
    }

    public setupRemoteConfigListener(): void {
        onConfigUpdate(this.remoteConfig, {
            next: async() => {
                await activate(this.remoteConfig);
            },
            error: (error: Error) => {
                // eslint-disable-next-line no-console
                console.error('Firebase Remote Config update error:', error);
            },
            complete: () => {
                // eslint-disable-next-line no-console
                console.log('Firebase Remote Config listener completed');
            }
        });
    }
}

